import Joi from 'joi';

/**
 * Schema for new record validation.
 */
export const createVehicleMakeSchema = () =>
	Joi.object({})
		// Ignore extra fields
		.unknown();
